import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Font } from 'components'
import { ReactComponent as MailIcon } from 'assets/images/mail.svg'
import styles from './styles.module.scss'

const url = 'https://api.getrecon.services/subscription/v1/subscribe?email='

const MailForm = ({ className }) => {
  const errorTimer = useRef(null)
  const responseTimer = useRef(null)

  const [value, setValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [responseError, setResponseError] = useState(false)
  const [requestComplete, setRequestComplete] = useState(false)

  const handleSubmit = event => {
    event.preventDefault()
    clearTimeout(errorTimer.current)
    clearTimeout(responseTimer.current)

    setResponseError(null)
    setRequestComplete(false)
    setIsLoading(true)

    fetch(`${url}${value}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(res => {
      if (res.status === 200) {
        setIsLoading(false)
        setValue('')
        setRequestComplete(true)
        responseTimer.current = setTimeout(
          () => setRequestComplete(false),
          5000,
        )
      } else {
        setIsLoading(false)
        setResponseError(true)
        errorTimer.current = setTimeout(() => setResponseError(false), 5000)
      }
    })
  }

  const handleChange = event => {
    setValue(event.target.value)
  }

  useEffect(() => {
    return () => {
      clearTimeout(errorTimer.current)
      clearTimeout(responseTimer.current)
    }
  }, [])

  return (
    <form onSubmit={handleSubmit}>
      <div className={cx(styles.container, className)}>
        <div className={styles.wrapper}>
          <MailIcon className={cx(styles.image, 'mr-16')} />
          <input
            type="email"
            placeholder="Type your email"
            className={cx(styles.field, className)}
            pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}"
            name="email"
            value={value}
            onChange={handleChange}
            required
          />
        </div>
        <button className={styles.button} type="submit">
          GET STARTED
        </button>

        {isLoading && <div className={styles.overflow} />}
      </div>
      <div className={cx(styles.messageBox, 'mt-16')}>
        {requestComplete && (
          <Font type="caption" color="white">
            Thanks for subscribing. A member of the Recon team will respond
            soon.
          </Font>
        )}
        {responseError && (
          <Font type="caption" color="error">
            Sorry, but something went wrong. Please, try again later.
          </Font>
        )}
      </div>
    </form>
  )
}

MailForm.propTypes = {
  className: PropTypes.string,
}

MailForm.defaultProps = {
  className: null,
}

export default MailForm
